
import React from 'react';

export const Instructions: React.FC<{ onAccept: () => void }> = ({ onAccept }) => {
  const generalRules = [
    "REACH THE COLLEGE PREMISES BEFORE 0830HRS. REGISTRATION DESK CLOSES PERMANENTLY AT 0830HRS.",
    "CARRY COLLEGE ID CARD AND ALUMNI CARD (OR REGISTRATION CONFIRMATION).",
    "ALL PARTICIPANTS MUST BE NCC CADETS. NO CIVILIANS ALLOWED.",
    "2nd & 3rd YEAR CADETS: BRING CATC CERTIFICATE + COLLEGE ID.",
    "1st YEAR CADETS: BRING COLLEGE ID + DOCUMENT WITH REGIMENTAL NUMBER.",
    "BRING NOMINAL ROLL COPY ATTESTED BY YOUR RESPECTIVE ANO.",
    "COMPLETE INDIVIDUAL NOMINAL ROLL FOR ALL PARTICIPANTS.",
    "COMPLETE SUMMARY NOMINAL ROLL FOR TOTAL STRENGTH.",
    "MAINTAIN DISCIPLINE. JUDGES DECISION IS FINAL."
  ];

  const eventRules = [
    { name: "QUARTER GUARD", rule: "6+2 formation. Dress: Uniform with Ceremonials." },
    { name: "SQUAD DRILL", rule: "9+1 formation. Dress: Uniform with Ceremonials." },
    { name: "TUG OF WAR (SD/SW)", rule: "8 players. Dress: Sportswear and DMS." },
    { name: "CULTURALS", rule: "Group dance (5-8 cadets). Max 4 mins." },
    { name: "VOLLEYBALL (SD)", rule: "6+2 players. B-Cert mandatory. Track dress." },
    { name: "EXHIBITION", rule: "4 cadets max. 3-min briefing required." }
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 animate-in fade-in slide-in-from-bottom-4">
      <h2 className="text-4xl font-stencil text-gold text-center mb-12 underline decoration-red-900 underline-offset-8">OFFICIAL INSTRUCTIONS</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className="glass p-8 rounded-2xl border-l-4 border-l-red-800">
          <h3 className="font-display font-bold text-xl mb-4 text-white uppercase tracking-wider">General Protocol</h3>
          <ul className="space-y-4">
            {generalRules.map((rule, idx) => (
              <li key={idx} className="flex gap-4 text-sm text-gray-300">
                <span className="font-stencil text-red-700">{idx + 1}.</span>
                <span>{rule}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="glass p-8 rounded-2xl border-l-4 border-l-gold">
          <h3 className="font-display font-bold text-xl mb-4 text-white uppercase tracking-wider">Event Highlights</h3>
          <div className="space-y-4">
            {eventRules.map((item, idx) => (
              <div key={idx} className="border-b border-white/5 pb-2">
                <p className="font-bold text-gold text-xs tracking-widest">{item.name}</p>
                <p className="text-sm text-gray-400">{item.rule}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="text-center">
        <button 
          onClick={onAccept}
          className="bg-red-800 hover:bg-red-700 text-white px-12 py-4 rounded-xl font-bold text-lg shadow-2xl shadow-red-900/40 transform hover:scale-105 transition-all"
        >
          UNDERSTOOD, PROCEED TO REGISTRATION
        </button>
      </div>
    </div>
  );
};
